import { FIELD_XXS, FIELD_XS, FIELD_S, FIELD_M, FIELD_L, FIELD_XL, FIELD_XXL, FIELD_NORMAL } from './const';
import { CONTROL_SIZE } from "../common/public";
export var calcWidth = function (size) {
    switch (size) {
        case CONTROL_SIZE.xxs:
            return FIELD_XXS;
        case CONTROL_SIZE.xs:
            return FIELD_XS;
        case CONTROL_SIZE.s:
            return FIELD_S;
        case CONTROL_SIZE.m:
            return FIELD_M;
        case CONTROL_SIZE.l:
            return FIELD_L;
        case CONTROL_SIZE.xl:
            return FIELD_XL;
        case CONTROL_SIZE.xxl:
            return FIELD_XXL;
        case CONTROL_SIZE.full:
            return '100%';
        default:
            return FIELD_NORMAL;
    }
};
export var customStyle = {
    border: '1px solid #54B948',
    backgroundColor: '#b8e0ff',
    padding: '7px',
    margin: '7px'
};
export function getCSSSizeValue(value, defaultValue) {
    value = typeof value === 'undefined' ? defaultValue : value;
    if (typeof value === 'number') {
        return value + "px";
    }
    return value;
}
//# sourceMappingURL=styles.js.map